import qs from "qs";
import uuid from "uuid";
import { DEV_MODE, setNewLocation, getLocationHash, localStorageSet, localStorageGet, getGoogleApi } from "./window";
import { getParameterByName } from './query-params';

const loadYoutubeClient = (handleYoutubeClientLoad) => {
  let googleApi = getGoogleApi();
  if (googleApi) {
    googleApi.load('client:auth2', () => initClient(handleYoutubeClientLoad) );
  } else {
    alert('Google API not available for load - refresh the page');
    handleYoutubeClientLoad({ youtubeClientLoaded: false });
  }
};

// https://developers.google.com/youtube/v3/guides/auth/client-side-web-apps#creatingclient
// https://developers.google.com/youtube/v3/quickstart/js
// const client_id = '548238540140-8e87un3ip8a8knoja3te37etghu6183t.apps.googleusercontent.com'; // PB App 1 - 1M req day
const client_id = '872701887463-ebbk1l9398ah2jq2c4nb9vc882n6og00.apps.googleusercontent.com'; // Winter Cargo 50M req day
const discovery_docs = ["https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest"];
const scopes = 'https://www.googleapis.com/auth/youtube';

const initClient = (handleYoutubeClientLoad) => {
  const googleApi = getGoogleApi();

  googleApi.client.init({
    clientId: client_id,
    discoveryDocs: discovery_docs,
    scope: scopes
  }).then(function () {
    handleYoutubeClientLoad({ youtubeClientLoaded: true });
  }).catch(() => {
    alert('YouTube Client Initialization Error - please refresh the page');
    handleYoutubeClientLoad({ youtubeClientLoaded: false });
  });
}

const handleAuthClick = () => {
  const googleApi = getGoogleApi();

  googleApi.auth2.getAuthInstance().signIn();
}

const handleSignoutClick = () => {
  const googleApi = getGoogleApi();

  googleApi.auth2.getAuthInstance().signOut();
}

const getYoutubeAccessToken = () => {
  const googleApi = getGoogleApi();

  if (googleApi) {
    return googleApi.client.getToken();
  }

  return null;
};

const isYoutubeAccessTokenValid = () => {
  return !!getYoutubeAccessToken();
};

export {
  loadYoutubeClient,
  handleAuthClick,
  handleSignoutClick,
  getYoutubeAccessToken,
  isYoutubeAccessTokenValid,
}



// WEBPACK FOOTER //
// ./src/lib/youtube-auth.js